module.exports = __webpack_public_path__ + "img/EgyptTechCatTriremeS_ua.ef2ef12d.webp";